import { render, staticRenderFns } from "./chatbot-btn.vue?vue&type=template&id=b5269910&scoped=true&"
import script from "./chatbot-btn.vue?vue&type=script&lang=js&"
export * from "./chatbot-btn.vue?vue&type=script&lang=js&"
import style0 from "./chatbot-btn.vue?vue&type=style&index=0&id=b5269910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5269910",
  null
  
)

export default component.exports